import React, { Fragment, useState } from 'react'
import ProjectInitiation from '../../Common/Component/ProjectInitiation';

const AsmAdminProjectInit = () => {
    return (
        <Fragment>
            <ProjectInitiation />
        </Fragment>
    )
}

export default AsmAdminProjectInit